import { Reveal, Overline } from "./Reveal";

const photos = [
  { src: "https://customer-assets.emergentagent.com/job_howell-strength/artifacts/6wzttq69_IMG_5282.webp", label: "Before" },
  { src: "https://customer-assets.emergentagent.com/job_howell-strength/artifacts/vsau8gd2_IMG_5279.webp", label: "Before" },
  { src: "https://customer-assets.emergentagent.com/job_howell-strength/artifacts/d0qvagqr_IMG_7913.webp", label: "After" },
  { src: "https://customer-assets.emergentagent.com/job_howell-strength/artifacts/php6i6h7_IMG_7917.webp", label: "After" },
];

export const Gallery = () => {
  return (
    <section id="gallery" className="relative py-24 md:py-32 bg-[#141414]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl">
          <Overline>My Transformation</Overline>
          <h2 className="font-display font-semibold uppercase tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl mt-4 leading-tight">
            250 Lbs To 150 Lbs. Real Proof.
          </h2>
          <p className="mt-5 text-[#A3A3A3]">
            This is my own journey — the same transformation I now help my clients achieve.
            Discipline, nutrition, and consistency changed everything.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
          {photos.map((p, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div
                data-testid={`gallery-item-${i}`}
                className="group relative overflow-hidden aspect-[3/4] border border-[#262626]"
              >
                <img
                  src={p.src}
                  alt={`Ryan Howell ${p.label}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/70 via-transparent to-transparent" />
                <span
                  className={`absolute top-3 left-3 text-[10px] uppercase tracking-widest font-bold px-3 py-1.5 ${
                    p.label === "After" ? "bg-[#0055FF] text-white" : "bg-[#0A0A0A]/80 text-white border border-[#262626]"
                  }`}
                >
                  {p.label}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-8 text-sm text-[#A3A3A3] italic">
            Your transformation could be featured here next.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
